<template>
    <div class="SiteFooter">
        <Container>
            <div class="main">
                <router-link to="/">
                    <Logo/>
                </router-link>
                <p>Manage your business more efficiently with our ticketing solution.</p>
            </div>

            <div class="aside">
                <div class="nav">
                    <h6>Features</h6>
                    <router-link to="/signup">Try DumpTek</router-link>
                </div>

                <div class="nav">
                    <h6>Company</h6>
                    <router-link to="/about">About</router-link>
                    <router-link to="/contact">Contact</router-link>
                </div>

                <div class="nav">
                    <h6>Legal</h6>
                    <router-link to="/privacy">Privacy</router-link>
                    <router-link to="/terms">Terms</router-link>
                </div>
            </div>
        </Container>
    </div>
</template>

<script>
import Logo from '@/components/Logo';

export default {
    name: 'SiteFooter',

    components: { Logo },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.SiteFooter {
    width: 100%;
    border-top: 1px solid $divider-color;
    padding: 50px 0 60px;
    background-color: $bg-color-1;

    .Container {
        display: flex;
        justify-content: space-between;

        @include breakpoint(sm) {
            flex-direction: column;
            align-items: center;
        }
    }

    .Logo {
        max-width: 200px;
        margin-bottom: $grid-gutter-width;

        @include breakpoint(sm) {
            margin: 0 auto;
        }
    }

    .main {
        max-width: 300px;

        @include breakpoint(sm) {
            margin-bottom: 30px;
            text-align: center;
        }
    }

    .aside {
        display: flex;

        @include breakpoint(xs) {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
        }
    }

    .nav {
        min-width: 100px;

        &:not(:first-child) {
            margin-left: 80px;

            @include breakpoint(xs) {
                margin-left: 0;
                margin-top: 30px;
            }
        }

        h6 {
            margin-bottom: 10px;
            font-size: 16px;
            text-transform: uppercase;
            font-weight: $font-weight-regular;
        }

        a {
            display: block;
            padding: 3px 0;
            color: $brand-primary;

            &:hover {
                text-decoration: underline;
            }
        }
    }
}
</style>
